module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('a', {
    attrs: {
      "id": "ch4"
    }
  }), _vm._v("ANTONIO PIGAFETTA AND THE MISSING DAY, 1522")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("A")]), _vm._v("fter three years, on September 7, 1522, "), _c('i', [_vm._v("Victoria")]), _vm._v(" returned to Spain from the first round-the-world voyage. It was the last remaining ship of Ferdinand Magellan’s tiny armada. Crewman Antonio Pigafetta had sailed west with the captain general through the tip of South America, endured the terrible three-month Pacific crossing, and witnessed Magellan’s death in the Philippines. All during the trip, Pigafetta had kept a daily journal. He was now puzzled. His journal marked the day as September 6, a day off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most people at the time believed the Bible taught that the earth was the center of the universe and the sun, moon, and stars revolved around it. Polish mathematician Copernicus believed the earth revolved around the sun and was slowly turning eastward, one trip around per day. By sailing westward, Magellan and Pigafetta ate up a day. The missing day confirmed Copernicus in the struggle between religion and science. "), _c('span', {
    staticClass: "color"
  }, [_vm._v("(03-057, 03-058)")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img11.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab5e9a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter004.vue
// module id = 87
// module chunks = 0